import LocalizedStrings from 'react-localization';

let TR = new LocalizedStrings({
  english:{
    cm_another_tab:'The app is open on another tab. Continue using it there.',
    cm_playlist:'Playlist',
    cm_current_music_playqueue:'Current music play queue',
    cm_play_now:'Play now',
    cm_add_to_list:'Add to list',
    cm_add_to_queue:'Add to queue',
    cm_performance_pos:'Position in the list',
    cm_cancel:'Cancel',
    cm_new_playlist:'New playlist',
    cm_name:'Name',
    cm_create:'Create',
    cm_name_cannot_be_empty:'Name cannot be empty',
    cm_songbook_queue:'SongBook queue',
    cm_current_playqueue:'Current play queue',
    cm_failed_to_create_singer:'Failed to create singer',
    cm_singer:'Singer',
    cm_no_singers:'No singers',
    cm_key_pitch:'Key/Pitch',
    cm_create_new_profile:'Create new singer profile',
    cm_singers_name:'Singer name',
    cm_go_to_shop_to_subscribe_and_return:'According to the Google Play policy, subscriptions cannot be made in this app. However, you can log in and subscribe on our website at www.muvika.com. Come back here then and click Ok.',
    cm_change:'Change',
    cm_change_song:'Change song',
    cm_save:'Save',
    cm_add_playqueue:'Should the tracks be added to the play queue?',
    cm_replace_or_add_playqueue:'Do you want to replace the current play queue with this playlist or should the tracks be added to the end of the playqueue?',
    cm_replace:'Replace',
    cm_add_to_end:'Add to the end',
    cm_are_you_sure_playlist:'Are you sure you want to replace the playlist with the current play queue?',
    cm_confirm_player_exit:'Exit karaoke player now?',
    cm_copy_noun:'Copy',
    cm_copy_playlist:'Copy playlist',
    cm_title:'Title',
    cm_artist:'Artist',
    cm_language:'Language',
    cm_label:'Label',
    cm_confirm_account_deletion:'Are you sure you want to DELETE your account permanently? To confirm, enter your password below.',
    cm_password:'Password',
    cm_delete_my_account:'Delete my account',
    cm_disable_smartq_now:'SmartQ is currently enabled. DISABLE now?',
    cm_retry:'Retry',
    cm_open_video_to_ext_screen_question:'External screen detected. Open video there?',
    cm_no:'No',
    cm_yes:'Yes',
    cm_facebook_login_removed:'Facebook login has been discontinued. If you have been logging into Muvika via Facebook and you want to keep your old user account, please contact us at support@muvika.com. You can also create a new account using your email address as username.',
    cm_close:'Close',
    cm_terms_and_conditions:'Terms of use',
    cm_i_have_read_and_agree:'I have read and agree to the',
    cm_change_password:'Change password',
    cm_current_password:'Current password',
    cm_new_password:'New password',
    cm_new_password_again:'New password again',
    cm_new_app_feedback_question:'What did you think about the new Muvika? Would you like to give feedback?',
    cm_ext_window_if_ipad:'If you are using iPad, please click Cancel. Casting video to tv will be soon available via our new iPad app.',
    cm_ext_window_if_mac:'If you are using Mac, and tv is connected to your computer, you can drag the video window to the tv screen.',
    cm_open_video_window:'Open video window',
    cm_message_from:'Message from Muvika',
    cm_go_to_shop_to_redeem_free_period_and_return:'According to the Google Play policy, subscriptions cannot be started in this app. However, you can log in and redeem your free trial period on our website at www.muvika.com. Come back here then and click Ok.',
    cm_confirm_recreate_sb_code:'Really change SongBook code now?',
    cm_recreate:'Recreate',
    cm_enter_pin:'Enter PIN code',
    cm_pin:'Pin code',
    cm_songbook_url_as_qrcode:'SongBook URL as QR code',
    cm_are_you_sure:'Are you sure?',
    cm_delete:'Delete',
    cm_create_new_style:'Create new style',
    cm_create_new_playlist:'Create new playlist',
    cm_select_song_pos:'Click to select song position',
    cm_enter_new_pin:'Enter new PIN code',
    cm_smartq_to_reorder_songs:'SmartQ will reorder songs now',
    cm_restore_song_to_smartq:'Restore song to SmartQ control?',
    cm_smartq_to_reorder_songs_save:'SmartQ will reorder songs after saving',
    cm_confirm_sb_prequeue_off:'Disable SongBook queue? Songs will go directly to the play queue.',
    cm_songbook_reject_confirmation:'Reject and remove selected requests?',
    cm_invalid_subscription:'You do not have a valid subscription at the moment.',
    cm_subscribe_now:'Subscribe now',
    cm_song_in_list_already_confirm:'The track is in the list already. Add anyway?',
    cm_add:'Add',
    cm_cancel_reason_question:'To help us make the service better, please let us know why you are canceling your subscription',
    cm_do_not_cancel:'Do not cancel',
    cm_cancel_subscription:'Cancel subscription',
    dp_muvika_app_will_be_updated:'Muvika application will be updated now',
    dp_update_now_question:'A new software version is available. Update now?',
    cm_software_update:'Software update',
    cm_clear:'Clear',
    cm_move_to_now_playing:'Move to now playing',
    cm_move_to_second:'Move to second',
    cm_move_up:'Move up',
    cm_move_down:'Move down',
    cm_move_to_bottom:'Move to bottom',
    cm_move_to_top:'Move to top',
    cm_edit:'Edit',
    cm_songs:'songs',
    cm_playlist_is_empty:'Playlist is empty',
    cm_lang_finnish:'Finnish',
    cm_error:'Error',
    cm_order:'Order',
    cm_session_start_failed:'Failed to connect to server to start a session. Please try again.',
    cm_rating:'Rating',
    cm_add_to_favorites:'Add to favorites',
    cm_select_singer:'Select singer',
    cm_vocal_version_available:'Vocal guide track available',
    cm_add_to_playlist:'Add to playlist',
    cm_after_this:'After this',
    cm_next:'Next',
    cm_performer_now:'Performing now',
    cm_playqueue_is_empty:'Play queue is empty',
    cm_select_new_song:'Now select new song',
    cm_now:'Now',
    cm_sb_track_changed:'The singer has changed the song',
    cm_enable_smartq_now:'SmartQ is currently disabled. ENABLE now and let SmartQ reorder songs?',
    cm_duration:'Duration',
    cm_song_pos_2:'2nd',
    cm_song_pos_3:'3rd',
    cm_song_pos_last:'Last',
    cm_song_pos_now:'Now',
    cm_song_pos_1:'1st',
    cm_other:'Other',
    cm_seach_text_too_short:'Search text is too short',
    cm_browse_results_by:'Browse results',
    cm_by_song:'By song title',
    cm_by_artist:'By artist name',
    cm_by_popularity:'By popularity',
    cm_filters:'Filters',
    cm_languages:'Languages',
    cm_all_languages:'All languages',
    cm_genres:'Genres',
    cm_all_genres:'All genres',
    cm_decades:'Decades',
    cm_all_decades:'All decades',
    cm_no_history:'No history',
    cm_accept:'Accept',
    cm_decline:'Decline',
    cm_number_of_songs_by_singer:'The number of songs in the play queue by this singer',
    cm_song_requester_ip_and_amount:'Song requester\'s IP address and number of requests in the last 12 hours',
    cm_song_requester_device_id_and_amount:'Song requester\'s device ID and number of requests in the last 12 hours',
    cm_set_light_theme:'Light theme',
    cm_set_dark_theme:'Dark theme',
    cm_lyrics_by:'Lyrics by',
    cm_composed_by:'Composed by',
    cm_published_by:'Published by',
    cm_song_request_sent:'Song request sent!',
    cm_no_exact_match_showing_similar:'No exact match, sounds similar',
    cm_trending_tracks:'Trending right now',
    cm_new:'New',
    cm_singers:'Singers',
    cm_favorites:'Favorites',
    cm_background_music:'Background music',
    cm_bg_player:'Player',
    cm_bg_styles:'Styles',
    cm_search:'Search',
    cm_playlists:'Playlists',
    ww_your_account_information:'Account information',
    cm_settings:'Settings',
    cm_feedback:'Feedback',
    cm_booth_mode:'Booth mode',
    cm_home:'Home',
    cm_browse:'Browse',
    cm_more:'More',
    cm_invalid_pin:'Invalid PIN code',
    cm_enable_songbook:'Enable SongBook',
    cm_clear_booth_session:'Clear session and restart booth mode?',
    cm_change_username:'Change username',
    cm_logout:'Log out',
    cm_external_link_account_ios:'To create or manage your account, please go to',
    cm_songbook:'Songbook',
    cm_songbook_info:'<h2>Information on Muvika SongBook</h2><p>Muvika SongBook makes it possible for everyone in a karaoke session to browse the song catalog and add songs to the player\'s playlist using their own mobile device. This is how it works:<ol><li>Open an internet browser on your mobile phone or tablet go to address <b>muvika.com/songs</b></li><li>Enter the SongBook ID that you can see in quotation marks on top of the Muvika streaming player screen (or in the bottom menu in mobile version)</li><li>Find a song you want to sing</li><li>Add the song as usual</li><li>On the playlist tab you can modify the <b><i>songs that you have added</i></b> or change their relative order.</li></ol>Song additions and changes will appear in the streaming player within 10 seconds.</p>',
    cm_register_clause:'Privacy statement',
    cm_playqueue:'Play queue',
    ww_page_title:'Karaoke streaming player | Muvika Online Karaoke',
    cm_select_state_or_province:'Select state or province',
    ww_passwords_must_match:'Passwords must match',
    cm_password_requirements:'Minimum password length is 8 characters',
    cm_select_your_country:'Select your country',
    cm_check_terms_and_conditions:'Please read and accept terms and conditions before using the service.',
    ss_failed_to_create_account:'Failed to create account',
    cm_country:'Country',
    cm_select:'Select',
    cm_state_or_province:'State or province',
    ww_enter_basic_account_info:'Please fill in some basic information below to complete the registration',
    cm_username:'Username',
    cm_firstname:'First name',
    cm_lastname:'Last name',
    cm_allow_newsletter:'I agree to receive information about new features and updates',
    cm_fill_all_fields:'Please fill all fields',
    ww_password_changed:'Password changed successfully',
    ww_password_too_short:'Password was too short',
    ss_failed_to_update_password:'Failed to update password',
    ww_enter_email_address_to_change_password_1:'Enter your username below. It is usually same as your email address.',
    ww_enter_email_address_to_change_password_2:'If you have forgotten your username, please contact customer support at support@muvika.com.',
    cm_account_creation_pin_sent:'A verification code has been sent to your email address. Please enter the code below.',
    cm_back:'Back',
    cm_register:'Sign up',
    cm_log_in:'Log in',
    cm_forgot_password:'Forgot password?',
    cm_facebook_login:'Facebook login',
    cm_failed_to_load_all_login_data:'Not all the account information could be loaded. Please try again later.',
    cm_chromecast_casting_error:'Chromecast casting error',
    cm_playlist_cleared_via_songbook:'Playlist cleared via SongBook',
    ww_account_created:'Account created',
    cm_redeem_your_free_period:'You can now redeem your free trial period in Muvika shop',
    cm_invalid_captcha_code:'Please type the numbers in the box again.',
    cm_invalid_email:'Email address is invalid',
    cm_enter_captcha_code:'Type the numbers in the box',
    cm_email:'Email',
    cm_welcome_to_songbook_public:'<h3>Welcome to Muvika SongBook!</h3><p>Here you can add your song to <b>%USER%\'s</b> playlist.</p>',
    cm_welcome_to_songbook_booth:'<h3>Welcome to Muvika SongBook!</h3><p>Here you can add your song to <b>%USER%\'s</b> playlist. (booth mode)</p>',
    cm_welcome_to_songbook_pro:'<h3>Welcome to Muvika SongBook!</h3><p>You can now add songs to <b>%USER%\'s</b> playlist. You can also modify the songs that <i>you</i> have added. Note that if you log out from SongBook and come back, you will not be recognized as the same singer.</p>',
    cm_songbook_id:'SongBook ID',
    cm_continue_after_subscription:'Click ok to continue to the karaoke player',
    cm_choose_your_song:'Choose your song',
    cm_code:'Code',
    cm_karaoke_for_home_use_only:'Muvika Karaoke for home use only',
    cm_stop:'Stop',
    cm_preview:'Preview',
    cm_wait:'Wait',
    cm_error_occurred:'An error occurred',
    cm_press_f11_for_fullscreen_in_extscreen:'Press F11 now to enlarge video to full screen',
    cm_mac_ipad_fullscreen:'On Mac, press CTRL+CMD+F now to enlarge video to full screen. On iPad, please install Muvika app in App Store to use external display.',
    cm_mac_ipad_click_fullscreen:'On Mac, click the video window and press CTRL+CMD+F to enlarge video to full screen. On iPad, please install Muvika app in App Store to use external display.',
    cm_press_f11_in_video_window:'Click in video window and then press F11',
    cm_chromebook_fullscreen:'Press the full screen key now to enlarge video',
    cm_sing_at_home_too:'Sing at home too! www.muvika.com',
    cm_latest_songs_in_catalog:'Latest additions in the catalog',
    cm_smartq_enabled_notif:'Note: Automatic playlist manager SmartQ is enabled. You can turn it off in the settings if you wish.',
    cm_history:'History',
    cm_window_perms:'Allow window management to enable external screen detection',
    cm_pause:'Pause',
    cm_play:'Play',
    cm_volume:'Volume',
    cm_previous:'Previous',
    cm_rewind_10s:'Rewind 10 s',
    cm_forward_10s:'Fast forward 10 s',
    cm_jump_to_music:'Jump to the position where music starts',
    cm_key:'Key',
    cm_switch_vocal_version:'Turn vocal guide track on or off',
    cm_autoplay_next:'Auto play next song',
    cm_detach_video:'Open video in new window',
    cm_attach_video:'Restore video',
    cm_fullscreen:'Full screen',
    cm_chromecast_timeout:'Chromecast device not found. Please check your wifi connection.',
    cm_disable_chromecast:'Stop casting to Chromecast',
    cm_enable_chromecast:'Play on Chromecast',
    cm_large_video:'Larger video screen',
    cm_small_video:'Smaller video screen',
    cm_video_is_in_external_window:'Video is in external window',
    cm_playing_background_music:'Background music is playing',
    ss_no_valid_subscription:'Subscription is not active',
    cm_press_f11_for_fullscreen:'Press F11 now to enlarge video to full screen and then close this dialog',
    cm_ext_screen_button_info_1:'You can connect your device to an external display with an HDMI cable and a suitable adapter, if you device support screen transfer.',
    cm_ext_screen_button_info_2:'Please contact customer support if you need more information.',
    ww_set_password:'Set password',
    cm_too_many_failed_attempts_try_later:'Too many failed attempts. Try again later.',
    cm_feedback_saved_thanks:'Your feedback was saved. Thanks!',
    cm_subscription_cancelled:'Your subscription was successfully cancelled',
    cm_office:'Office',
    cm_company:'Company',
    cm_business_id:'Business ID',
    cm_tax_number:'VAT number',
    cm_address:'Street',
    cm_zip:'Zip',
    cm_city:'City',
    cm_phone:'Phone',
    cm_renew_subs:'Renew',
    cm_cancel_subs:'Cancel subscription',
    cm_update_payment_card:'Update card',
    cm_transactions:'Transactions',
    cm_go_to_shop_question:'Giftcard or other order?',
    cm_go_to_shop:'Go to Muvika Shop',
    cm_current_subscription:'Current subscription',
    cm_payment_method:'Payment method',
    cm_delete_account:'Delete account',
    cm_subscription_info:'Subscription info',
    cm_my_account:'My account',
    cm_area:'Area',
    cm_matching_tracks:'Matching tracks on server',
    cm_waiting_for_karaoke_to_finish:'Waiting for karaoke to finish',
    cm_enable_background_music:'Play background music between karaoke songs',
    cm_style_applied:'Style applied',
    cm_open_styles:'Open styles',
    cm_bg_auto_from_style:'Add tracks automatically from a style',
    ss_disabled:'disabled',
    cm_bg_currently_playlists:'Repeating playlist',
    cm_stop_repeat:'Stop repeat',
    cm_bg_playlists:'Playlists - background music',
    cm_song_artist_or_code:'Song artist or code',
    cm_song_title_or_code:'Song title or code',
    cm_song_title_artist_or_code:'Song title, artist or code',
    cm_total:'Total',
    cm_bg_search:'Search - background music',
    cm_song_title:'Song',
    cm_bg_save_current:'Save current style',
    cm_use:'Use',
    cm_load:'Load',
    cm_username_cannot_be_empty:'Username cannot be empty',
    cm_bad_username_or_pw:'Email or password is incorrect',
    cm_new_username_email:'New username (email address)',
    cm_find:'Find',
    cm_set_description:'Description can\'t be empty',
    cm_set_feedback_type:'Choose feedback type',
    cm_send:'Send',
    cm_suggestion_additional_info:'Additional information',
    cm_suggestion_additional_info_placeholder:'If you know which album the song appears on, or on which streaming service, or if you have any other relevant information. You may leave this field blank.',
    cm_description:'Description',
    cm_feedback_type:'Feedback type',
    cm_bug_report:'Bug report',
    cm_song_suggestion:'Song request',
    cm_feature_request_or_improvement:'Feature request or improvement',
    cm_news:'News',
    cm_recommended_playlists:'Inspiration from playlists',
    cm_video:'Video',
    cm_autoplay_delay_secs:'Auto play delay (secs)',
    cm_num_next_singers_shown:'Number of next singers shown',
    cm_allow_playlist_view:'Allow user to view playlist',
    cm_max_songs_from_same_singer:'Max songs from same singer in queue',
    cm_show_qrcode:'Show QR code',
    cm_enable_smartq:'Enable SmartQ',
    cm_other_options:'Other',
    cm_select_font:'Font size',
    cm_from_list:'from list',
    cm_by_typing:'type in',
    cm_history_size:'History size',
    cm_enable_settings_pin:'Protect settings with PIN',
    cm_enable_account_pin:'Protect account info with PIN',
    cm_hide_play_now:'Hide Play now button',
    cm_usage_mode:'Usage mode',
    cm_restaurant:'Restaurant',
    cm_booth:'Booth',
    cm_smartq_info:'<h2>SmartQ - A smart playlist manager</h2><p>When SmartQ is enabled, the songs are automatically sorted so that all singers get a fair chance to sing.</p><p>You can still move songs manually if you wish to override the order.</p><p>How it works:<ul><li>SmartQ uses playback history from the last six hours to arrange the songs. If you want to reset, simply clear the history.</li><li>The two topmost songs are “locked" and remain untouched by SmartQ.</li><li>SmartQ works best when there are many singers and the order is not edited manually.</li><li>New singers are given a high priority as SmartQ sorts between those who have already sung and have multiple songs in the list.</li></ul>',
    cm_your_pending_song_requests:'Your pending song requests',
    cm_songbook_playlist_boothmode_info:'You can modify the songs added on this device',
    cm_songbook_playlist_home_info:'You can modify the songs you have added yourself',
    cm_songbook_playlist_pro_info:'Here you can see and modify the songs you have added yourself',
    cm_enabled:'Enabled',
    cm_no_song_requests:'No song requests waiting',
    cm_songbook_preapproval:'SongBook request pre-approval',
    cm_network_connection_error:'Network connection error',
    cm_saved:'Saved!',
    ww_username_hanged:'Username changed successfully',
    cm_deleted_big:'Deleted!',
    cm_style_exists_already:'Style with the same name exists already',
    cm_same_playlist_exists_already:'Playlist with the same name exists already',
    cm_playlist_saved:'Playlist saved',
    cm_max_number_of_songs_reached:'Maximum numbers of songs reached',
    cm_added:'Added',
    cm_created:'Created'
  },
  finnish:{
    cm_another_tab:'Sovellus on auki toisella välilehdellä. Jatka sovelluksen käyttämistä siellä.',
    cm_playlist:'Soittolista',
    cm_current_music_playqueue:'Nykyinen musiikin soittojono',
    cm_play_now:'Soita heti',
    cm_add_to_list:'Lisää listalle',
    cm_add_to_queue:'Lisää jonoon',
    cm_performance_pos:'Sijainti listalla',
    cm_cancel:'Keskeytä',
    cm_new_playlist:'Uusi soittolista',
    cm_name:'Nimi',
    cm_create:'Luo',
    cm_name_cannot_be_empty:'Nimi ei voi olla tyhjä',
    cm_songbook_queue:'SongBook-jono',
    cm_current_playqueue:'Nykyinen soittojono',
    cm_failed_to_create_singer:'Laulajaprofiilin luominen epäonnistui',
    cm_singer:'Laulaja',
    cm_no_singers:'Ei laulajia',
    cm_key_pitch:'Sävelkorkeus',
    cm_create_new_profile:'Luo uusi laulaja',
    cm_singers_name:'Laulajan nimi',
    cm_go_to_shop_to_subscribe_and_return:'Google Playn käyttöehtojen mukaisesti tilauksia ei voi tehdä tämän sovelluksen sisällä. Voit kirjautua sisään ja tehdä tilauksen nettisivullamme www.muvika.com. Palaa sen jälkeen sovellukseen ja paina Ok.',
    cm_change:'Vaihda',
    cm_change_song:'Vaihda biisi',
    cm_save:'Tallenna',
    cm_add_playqueue:'Lisätäänkö kappaleet jonoon?',
    cm_replace_or_add_playqueue:'Korvataanko nykyinen soittojono tällä listalla, vai lisätäänkö kappaleet jonon perään?',
    cm_replace:'Korvaa',
    cm_add_to_end:'Lisää soittojonoon',
    cm_are_you_sure_playlist:'Oletko varma että haluat korvata soittolistan nykyisellä soittojonolla?',
    cm_confirm_player_exit:'Poistutaan karaokesoittimesta?',
    cm_copy_noun:'Kopio',
    cm_copy_playlist:'Kopioi soittolista',
    cm_title:'Nimi',
    cm_artist:'Esittäjä',
    cm_language:'Kieli',
    cm_label:'Katalogi',
    cm_confirm_account_deletion:'Oletko aivan varma, että haluat POISTAA käyttäjätilin lopullisesti? Vahvista tilin poistaminen salasanallasi:',
    cm_password:'Salasana',
    cm_delete_my_account:'Poista käyttäjätilini',
    cm_disable_smartq_now:'SmartQ on tällä hetkellä käytössä. Poistetaanko käytöstä?',
    cm_retry:'Yritä uudelleen',
    cm_open_video_to_ext_screen_question:'Ulkoinen näyttö havaittu. Avataanko video sinne?',
    cm_no:'Ei',
    cm_yes:'Kyllä',
    cm_facebook_login_removed:'Facebook-kirjautuminen on poistunut käytöstä. Jos olet aiemmin kirjautunut Muvikaan Facebookin kautta ja haluat säilyttää vanhan tilisi, ota yhteyttä asiakaspalveluun asiakaspalvelu@muvika.com, puh. 010 326 3130 (arkisin 9-18). Voit myös luoda uuden tilin käyttäen sähköpostiosoitettasi käyttäjätunnuksena.',
    cm_close:'Sulje',
    cm_terms_and_conditions:'Käyttöehdot',
    cm_i_have_read_and_agree:'Olen lukenut ja hyväksyn',
    cm_change_password:'Vaihda salasana',
    cm_current_password:'Nykyinen salasana',
    cm_new_password:'Uusi salasana',
    cm_new_password_again:'Uusi salasana uudestaan',
    cm_new_app_feedback_question:'Miltä uusi Muvika vaikutti? Haluaisitko antaa palautetta?',
    cm_ext_window_if_ipad:'Jos olet iPad-käyttäjä, ole hyvä ja paina tässä Keskeytä. Videon siirto tv:lle onnistuu pian saatavilla olevan uuden iPad-sovelluksemme kautta.',
    cm_ext_window_if_mac:'Jos olet Mac-käyttäjä, ja tv on kytketty laitteeseesi, voit vetää avautuvan ikkunan tv:n ruudulle.',
    cm_open_video_window:'Avaa videoikkuna',
    cm_message_from:'Viesti Muvikalta',
    cm_go_to_shop_to_redeem_free_period_and_return:'Google Playn käyttöehtojen mukaisesti tilauksia ei voi aloittaa tämän sovelluksen sisällä. Voit kirjautua sisään ja lunastaa ilmaisen kokeilujakson nettisivullamme www.muvika.com. Palaa sen jälkeen sovellukseen ja paina Ok.',
    cm_confirm_recreate_sb_code:'Haluat varmasti vaihtaa SongBook-koodin?',
    cm_recreate:'Luo uusi',
    cm_enter_pin:'Syötä PIN-koodi',
    cm_pin:'PIN-koodi',
    cm_songbook_url_as_qrcode:'SongBook-osoite QR-koodina',
    cm_are_you_sure:'Oletko varma?',
    cm_delete:'Poista',
    cm_create_new_style:'Luo uusi tyyli',
    cm_create_new_playlist:'Luo uusi soittolista',
    cm_select_song_pos:'Valitse sijainti klikkaamalla',
    cm_enter_new_pin:'Syötä uusi PIN-koodi',
    cm_smartq_to_reorder_songs:'SmartQ järjestää kappaleet nyt uudestaan',
    cm_restore_song_to_smartq:'Palautetaan kappale SmartQ:n hallintaan?',
    cm_smartq_to_reorder_songs_save:'SmartQ järjestää kappaleet tallennuksen jälkeen uudestaan',
    cm_confirm_sb_prequeue_off:'Otetaan SongBook-jono pois päältä? Kappaleet menevät jatkossa suoraan soittojonoon.',
    cm_songbook_reject_confirmation:'Hylkää ja poista valitut pyynnöt?',
    cm_invalid_subscription:'Jäsenyytesi ei ole tällä hetkellä voimassa.',
    cm_subscribe_now:'Tilaa nyt',
    cm_song_in_list_already_confirm:'Kappale on jo soittolistalla. Lisätään silti?',
    cm_add:'Lisää',
    cm_cancel_reason_question:'Harmillista että olet peruuttamassa tilauksesi. Jotta voisimme kehittää palvelua, olisimme kiitollisia jos kertoisit, mistä syystä olet keskeyttämässä:',
    cm_do_not_cancel:'En keskeytä',
    cm_cancel_subscription:'Keskeytän tilauksen',
    dp_muvika_app_will_be_updated:'Muvika-sovellus päivitetään nyt',
    dp_update_now_question:'Uusi ohjelmaversio on saatavilla. Päivitetäänkö nyt?',
    cm_software_update:'Ohjelmistopäivitys',
    cm_clear:'Tyhjennä',
    cm_move_to_now_playing:'Siirrä nyt soivaksi',
    cm_move_to_second:'Siirrä toiseksi',
    cm_move_up:'Siirrä ylöspäin',
    cm_move_down:'Siirrä alaspäin',
    cm_move_to_bottom:'Siirrä viimeiseksi',
    cm_move_to_top:'Siirrä ensimmäiseksi',
    cm_edit:'Muokkaa',
    cm_songs:'kappaletta',
    cm_playlist_is_empty:'Soittolista on tyhjä',
    cm_lang_finnish:'Suomi',
    cm_error:'Virhe',
    cm_order:'Tilaus',
    cm_session_start_failed:'Palvelimeen ei saatu yhteyttä session aloittamiseksi. Yritä uudelleen.',
    cm_rating:'Arvio',
    cm_add_to_favorites:'Lisää suosikkeihin',
    cm_select_singer:'Valitse laulaja',
    cm_vocal_version_available:'Opaslauluraita saatavilla',
    cm_add_to_playlist:'Lisää soittolistalle',
    cm_after_this:'Tämän jälkeen',
    cm_next:'Seuraava',
    cm_performer_now:'Nyt vuorossa',
    cm_playqueue_is_empty:'Soittojono on tyhjä',
    cm_select_new_song:'Hae nyt uusi kappale',
    cm_now:'Nyt',
    cm_sb_track_changed:'Laulaja on vaihtanut kappaletta',
    cm_enable_smartq_now:'SmartQ ei ole tällä hetkellä käytössä. Otetaanko käyttöön ja annetaan SmartQ:n järjestellä kappaleet?',
    cm_duration:'Kesto',
    cm_song_pos_2:'2.',
    cm_song_pos_3:'3.',
    cm_song_pos_last:'Viim.',
    cm_song_pos_now:'Nyt',
    cm_song_pos_1:'1.',
    cm_other:'Muu',
    cm_seach_text_too_short:'Hakusana on liian lyhyt',
    cm_browse_results_by:'Selaa tuloksia',
    cm_by_song:'Kappaleen mukaan',
    cm_by_artist:'Esittäjän mukaan',
    cm_by_popularity:'Suosituimmat ensin',
    cm_filters:'Suodattimet',
    cm_languages:'Kielet',
    cm_all_languages:'Kaikki kielet',
    cm_genres:'Genret',
    cm_all_genres:'Kaikki genret',
    cm_decades:'Vuosikymmenet',
    cm_all_decades:'Kaikki vuodet',
    cm_no_history:'Ei historiaa',
    cm_accept:'Hyväksy',
    cm_decline:'Hylkää',
    cm_number_of_songs_by_singer:'Laulajan kappaleiden määrä tällä hetkellä soittojonossa',
    cm_song_requester_ip_and_amount:'Kappaleen lähettäjän IP-osoite ja kappaleiden määrä viimeisen 12 tunnin aikana',
    cm_song_requester_device_id_and_amount:'Kappaleen lähettäjän laitetunniste ja kappaleiden määrä viimeisen 12 tunnin aikana',
    cm_set_light_theme:'Vaalea teema',
    cm_set_dark_theme:'Tumma teema',
    cm_lyrics_by:'Sanoitus',
    cm_composed_by:'Sävellys',
    cm_published_by:'Kustantaja',
    cm_song_request_sent:'Kappale lähetetty!',
    cm_no_exact_match_showing_similar:'Ei tarkkaa osumaa, kuulostaa samalta',
    cm_trending_tracks:'Pinnalla juuri nyt',
    cm_new:'Uudet',
    cm_singers:'Laulajat',
    cm_favorites:'Suosikit',
    cm_background_music:'Taustamusiikki',
    cm_bg_player:'Soitin',
    cm_bg_styles:'Tyylit',
    cm_search:'Haku',
    cm_playlists:'Soittolistat',
    ww_your_account_information:'Käyttäjätilin tiedot',
    cm_settings:'Asetukset',
    cm_feedback:'Palaute',
    cm_booth_mode:'Koppimoodi',
    cm_home:'Koti',
    cm_browse:'Selaa',
    cm_more:'Lisää',
    cm_invalid_pin:'Väärä PIN-koodi',
    cm_enable_songbook:'Salli SongBook',
    cm_clear_booth_session:'Tyhjennä istunnon tiedot ja aloita koppimoodi uudestaan?',
    cm_change_username:'Vaihda tunnus',
    cm_logout:'Kirjaudu ulos',
    cm_external_link_account_ios:'Luodaksesi tai hallitaksesi tunnustasi, ole hyvä ja mene sivullemme',
    cm_songbook:'Songbook',
    cm_songbook_info:'  <h2>Tietoa Muvika SongBookista</h2>  <p>  Muvika SongBookin avulla kaikki karaokeen osallistuvat voivat selata katalogia ja  valita kappaleensa itsenäisesti käyttäen omaa päätelaitettaan. Kappaleiden haku ei siten häiritse itse laulamista. Toimi näin:  <ol>    <li>Mene esim. kännykän internet-selaimella osoitteeseen <b>muvika.com/songs</b> syöttämällä se selaimen osoiteriville</li>    <li>Syötä Muvikan karaokesovelluksen ruudun ylälaidassa lainausmerkeissä näkyvä tunniste (mobiiliversiossa alavalikossa)</li>    <li>Etsi haluamasi kappale</li>    <li>Lisää kappale soittolistalle normaalilla tavalla</li>    <li>Soittolista-välilehdellä näet soittolistan tilanteen ja voit muokata <b><i>itse lisäämiäsi</i></b> kappaleita tai muuttaa niiden keskinäistä järjestystä.</li>  </ol>  Lisäykset ja muutokset päivittyvät karaokesoittimeen viimeistään noin 10 sekunnin päästä.  </p>',
    cm_register_clause:'Rekisteriseloste',
    cm_playqueue:'Soittojono',
    ww_page_title:'Karaoke netissä | Muvika Online Karaoke',
    cm_select_state_or_province:'Valitse osavaltio',
    ww_passwords_must_match:'Salasanat eivät täsmää',
    cm_password_requirements:'Salasanan minimipituus on 8 merkkiä',
    cm_select_your_country:'Valitse maa',
    cm_check_terms_and_conditions:'Ole hyvä ja tarkista käyttöehdot ennen kuin aloitat palvelun käytön.',
    ss_failed_to_create_account:'Käyttäjätilin luominen epäonnistui',
    cm_country:'Maa',
    cm_select:'Valitse',
    cm_state_or_province:'Lääni tai osavaltio',
    ww_enter_basic_account_info:'Täytä alla olevat tiedot tunnuksen luomiseksi',
    cm_username:'Käyttäjätunnus',
    cm_firstname:'Etunimi',
    cm_lastname:'Sukunimi',
    cm_allow_newsletter:'Minulle saa lähettää tietoa uudistuksista palvelussa',
    cm_fill_all_fields:'Täytä kaikki kentät',
    ww_password_changed:'Salasana on vaihdettu onnistuneesti',
    ww_password_too_short:'Salasana oli liian lyhyt',
    ss_failed_to_update_password:'Salasanan asetus epäonnistui',
    ww_enter_email_address_to_change_password_1:'Syötä tähän käyttäjätunnuksesi. Se on yleensä sama kuin sähköpostiosoitteesi.',
    ww_enter_email_address_to_change_password_2:'Jos olet unohtanut käyttäjätunnuksesi, ota yhteyttä asiakaspalveluun osoitteessa asiakaspalvelu@muvika.com tai puh. 010 326 3130 (ark. 9-18).',
    cm_account_creation_pin_sent:'Vahvistuskoodi on lähetetty sähköpostiosoitteeseesi. Syötä koodi alla olevaan laatikkoon.',
    cm_back:'Takaisin',
    cm_register:'Luo tunnus',
    cm_log_in:'Kirjaudu sisään',
    cm_forgot_password:'Unohditko salasanasi?',
    cm_facebook_login:'Facebook login',
    cm_failed_to_load_all_login_data:'Kaikkia käyttäjätilin tietoja ei pystytty lataamaan. Yritä myöhemmin uudestaan.',
    cm_chromecast_casting_error:'Chromecast-virhe',
    cm_playlist_cleared_via_songbook:'Soittolista tyhjennetty SongBookin kautta',
    ww_account_created:'Käyttäjätilisi on luotu',
    cm_redeem_your_free_period:'Voit nyt lunastaa ilmaisen kokeilujaksosi Muvika-kaupasta',
    cm_invalid_captcha_code:'Syötä laatikon numerot uudelleen.',
    cm_invalid_email:'Virheellinen sähköpostiosoite',
    cm_enter_captcha_code:'Syötä laatikon numerot',
    cm_email:'Sähköposti',
    cm_welcome_to_songbook_public:'<h3>Tervetuloa Muvika SongBookiin!</h3><p>Tästä voit lisätä oman kappaleesi käyttäjän <b>%USER%</b> soittolistalle.</p>',
    cm_welcome_to_songbook_booth:'<h3>Tervetuloa Muvika SongBookiin!</h3><p>Tästä voit lisätä oman kappaleesi käyttäjän <b>%USER%</b> soittolistalle. (booth mode)</p>',
    cm_welcome_to_songbook_pro:'<h3>Tervetuloa Muvika SongBookiin!</h3><p>Voit nyt lisätä haluamiasi kappaleita käyttäjän <b>%USER%</b> soittolistalle. Voit myös muokata <i>itse lisäämiäsi</i> kappaleita, jotka ovat jo soittolistalla. Huomaa että jos kirjaudut ulos SongBookista ja palaat takaisin, sinua ei tunnisteta enää samaksi laulajaksi.</p>',
    cm_songbook_id:'SongBook-tunniste',
    cm_continue_after_subscription:'Paina ok ja jatkaaksesi karaokesoittimeen',
    cm_choose_your_song:'Valitse kappaleesi',
    cm_code:'Koodi',
    cm_karaoke_for_home_use_only:'Muvika Karaoke vain kotikäyttöön',
    cm_stop:'Pysäytä',
    cm_preview:'Esikatselu',
    cm_wait:'Odota',
    cm_error_occurred:'Tapahtui virhe',
    cm_press_f11_for_fullscreen_in_extscreen:'Paina nyt F11 jotta video laajenee kokoruutunäyttöön',
    cm_mac_ipad_fullscreen:'Jos käytät Macia, paina nyt CTRL+CMD+F jotta video laajenee kokoruutunäyttöön. Jos käytät iPadia, asenna Muvikan sovellus App Storesta käyttääksesi ulkoista näyttöä.',
    cm_mac_ipad_click_fullscreen:'Jos käytät Macia, klikkaa videoikkunaa ja paina CTRL+CMD+F jotta video laajenee kokoruutunäyttöön. Jos käytät iPadia, asenna Muvikan sovellus App Storesta käyttääksesi ulkoista näyttöä.',
    cm_press_f11_in_video_window:'Klikkaa videoikkunaa ja paina sitten F11',
    cm_chromebook_fullscreen:'Paina nyt näppäimistön fullscreen-näppäintä jotta video laajenee kokoruutunäyttöön',
    cm_sing_at_home_too:'Laula myös kotona! www.muvika.com',
    cm_latest_songs_in_catalog:'Uusimpia kappaleita katalogissa',
    cm_smartq_enabled_notif:'Huomaa: Automaattinen soittolistan järjestäjä SmartQ on käytössä. Voit halutessasi ottaa sen pois päältä asetuksista.',
    cm_history:'Historia',
    cm_window_perms:'Salli ikkunoiden hallinta jos haluat että mahd. ulkoinen näyttö tunnistetaan',
    cm_pause:'Tauko',
    cm_play:'Soita',
    cm_volume:'Äänenvoimakkuus',
    cm_previous:'Edellinen',
    cm_rewind_10s:'Taaksepäin 10 s',
    cm_forward_10s:'Eteenpäin 10 s',
    cm_jump_to_music:'Hyppää siihen kohtaan, jossa itse musiikki alkaa',
    cm_key:'Korkeus',
    cm_switch_vocal_version:'Laita opaslauluraita päälle tai pois',
    cm_autoplay_next:'Soita seuraava automaattisesti',
    cm_detach_video:'Avaa video omaan ikkunaan',
    cm_attach_video:'Palauta video omasta ikkunasta',
    cm_fullscreen:'Kokoruutunäyttö',
    cm_chromecast_timeout:'Chromecast-laitetta ei löytynyt. Tarkista wifi-yhteys.',
    cm_disable_chromecast:'Lopeta Chromecast-toisto',
    cm_enable_chromecast:'Toista Chromecastilla',
    cm_large_video:'Isompi videokuva',
    cm_small_video:'Pienempi videokuva',
    cm_video_is_in_external_window:'Video on ulkoisessa ikkunassa',
    cm_playing_background_music:'Taustamusiikki soi',
    ss_no_valid_subscription:'Käyttöoikeus ei ole voimassa',
    cm_press_f11_for_fullscreen:'Paina nyt F11 jotta video laajenee kokoruutunäyttöön (sulje vasta sen jälkeen tämä kehote)',
    cm_ext_screen_button_info_1:'Voit kytkeä laitteesi ulkoiseen näyttöön HDMI-johdolla ja adapterilla, jos laitteesi tukee kuvan siirtoa.',
    cm_ext_screen_button_info_2:'Asiakaspalvelu neuvoo tarvittaessa asiassa.',
    ww_set_password:'Aseta salasana',
    cm_too_many_failed_attempts_try_later:'Liian monta yritystä. Kokeile myöhemmin uudelleen.',
    cm_feedback_saved_thanks:'Palautteesi on tallennettu. Kiitos!',
    cm_subscription_cancelled:'Tilauksesi on nyt keskeytetty',
    cm_office:'Toimipiste',
    cm_company:'Yritys',
    cm_business_id:'Y-tunnus',
    cm_tax_number:'VAT-tunnus',
    cm_address:'Katuosoite',
    cm_zip:'Postinumero',
    cm_city:'Kaupunki',
    cm_phone:'Puhelin',
    cm_renew_subs:'Uusi tilaus',
    cm_cancel_subs:'Keskeytä tilaus',
    cm_update_payment_card:'Päivitä maksukortti',
    cm_transactions:'Maksutapahtumat',
    cm_go_to_shop_question:'Lahjakortti tai muu tilaus?',
    cm_go_to_shop:'Mene Muvika-kauppaan',
    cm_current_subscription:'Nykyinen tilaus',
    cm_payment_method:'Maksutapa',
    cm_delete_account:'Poista käyttäjätili',
    cm_subscription_info:'Tilauksen tiedot',
    cm_my_account:'Omat tietoni',
    cm_area:'Alue',
    cm_matching_tracks:'Hakuehtoja vastaavia kappaleita',
    cm_waiting_for_karaoke_to_finish:'Odotetaan karaoken loppumista',
    cm_enable_background_music:'Soita taustamusiikkia karaokekappaleiden välissä',
    cm_style_applied:'Tyyli otettu käyttöön',
    cm_open_styles:'Avaa tyylit',
    cm_bg_auto_from_style:'Lisää automaattisesti kappaleita jonoon tyylistä',
    ss_disabled:'pois käytöstä',
    cm_bg_currently_playlists:'Soitetaan toistuvasti listaa',
    cm_stop_repeat:'Lopeta toisto',
    cm_bg_playlists:'Soittolistat - taustamusiikki',
    cm_song_artist_or_code:'Kappaleen esittäjä tai koodi',
    cm_song_title_or_code:'Kappaleen nimi tai koodi',
    cm_song_title_artist_or_code:'Kappaleen nimi, esittäjä tai koodi',
    cm_total:'Yhteensä',
    cm_bg_search:'Haku - taustamusiikki',
    cm_song_title:'Kappale',
    cm_bg_save_current:'Tallenna nykyinen tyyli',
    cm_use:'Käytä',
    cm_load:'Lataa',
    cm_username_cannot_be_empty:'Käyttäjätunnus ei voi olla tyhjä',
    cm_bad_username_or_pw:'Virheellinen käyttäjätunnus tai salasana',
    cm_new_username_email:'Uusi käyttäjätunnus (sähköpostiosoite)',
    cm_find:'Löydä',
    cm_set_description:'Kuvaus ei voi olla tyhjä',
    cm_set_feedback_type:'Valitse palautteen tyyppi',
    cm_send:'Lähetä',
    cm_suggestion_additional_info:'Lisätietoa kappaleesta',
    cm_suggestion_additional_info_placeholder:'Kerro jos tiedät millä levyllä tai missä palvelussa kappale esiintyy, tai muuta tietoa kappaleen versiosta. Voi jättää tyhjäksi.',
    cm_description:'Kuvaus',
    cm_feedback_type:'Palautteen tyyppi',
    cm_bug_report:'Bugiraportti',
    cm_song_suggestion:'Kappaletoive',
    cm_feature_request_or_improvement:'Uusi ominaisuus tai parannus',
    cm_news:'Uutiset',
    cm_recommended_playlists:'Inspiraatiota soittolistoilta',
    cm_video:'Video',
    cm_autoplay_delay_secs:'Autom. soiton viive (sek)',
    cm_num_next_singers_shown:'Seuraavia laulajia näytetään',
    cm_allow_playlist_view:'Salli soittolistanäkymä',
    cm_max_songs_from_same_singer:'Enintään biisejä samalta laulajalta jonossa',
    cm_show_qrcode:'Näytä QR-koodi',
    cm_enable_smartq:'SmartQ käytössä',
    cm_other_options:'Muut',
    cm_select_font:'Fonttikoko',
    cm_from_list:'listasta',
    cm_by_typing:'kirjoittamalla',
    cm_history_size:'Historian koko',
    cm_enable_settings_pin:'Suojaa asetukset PIN-koodilla',
    cm_enable_account_pin:'Suojaa käyttäjätiedot PIN-koodilla',
    cm_hide_play_now:'Piilota Soita heti -painike',
    cm_usage_mode:'Käyttötila',
    cm_restaurant:'Ravintola',
    cm_booth:'Koppi',
    cm_smartq_info:'<h2>SmartQ - Oikeudenmukainen soittolistan järjestelijä</h2><p>Kun SmartQ on käytössä, automatiikka valitsee kappaleiden järjestyksen niin, ettei yksi ja sama laulaja ei ole äänessä koko ajan, vaan kaikki pääsevät sopivin väliajoin laulamaan.</p><p>Jos SmartQ:n kappaleelle antama paikka ei tyydytä, voit siirtää sen myös käsin haluamaasi kohtaan.</p><p>Hyvä tietää:<ul><li>SmartQ käyttää järjestyksen valitsemiseen soittohistorian tietoja viimeisen kuuden tunnin ajalta. Jos haluat nollata tilanteen, voit tyhjentää soittohistorian</li><li>Kaksi ylintä kappaletta on "lukittu", eikä SmartQ enää koske niihin</li><li>SmartQ toimii parhaiten kun laulajia on paljon, eikä järjestykseen kosketa käsin</li><li>SmartQ suosii uusia laulajia (jotka eivät ole vielä sessiossa laulaneet), mutta antaa toki vuoroja myös jo laulaneille.</li></ul>',
    cm_your_pending_song_requests:'Odottavat kappaletoiveesi',
    cm_songbook_playlist_boothmode_info:'Voit muokata niitä kappaleita, jotka on lisätty tällä laitteella',
    cm_songbook_playlist_home_info:'Voit muokata niitä kappaleita, jotka olet itse lisännyt soittolistalle',
    cm_songbook_playlist_pro_info:'Näet tässä soittolistalle itse jättämäsi kappaleet, ja voit muokata niitä',
    cm_enabled:'Käytössä',
    cm_no_song_requests:'Ei odottavia kappalepyyntöjä',
    cm_songbook_preapproval:'SongBook-pyyntöjen esitarkistus',
    cm_network_connection_error:'Verkkoyhteysvirhe',
    cm_saved:'Tallennettu!',
    ww_username_hanged:'Käyttäjätunnus vaihdettu onnistuneesti',
    cm_deleted_big:'Poistettu!',
    cm_style_exists_already:'Samanniminen tyyli on jo olemassa',
    cm_same_playlist_exists_already:'Samanniminen soittolista on jo olemassa',
    cm_playlist_saved:'Soittolista tallennettu',
    cm_max_number_of_songs_reached:'Kappaleiden maksimäärä saavutettu',
    cm_added:'Lisätty',
    cm_created:'Luotu'
  },
});

export default TR;
